import { InfoSectionItem } from "./types";

export const INFO_ITEMS: InfoSectionItem[] = [
  {
    icon: "pi pi-info-circle",
    title: "Information",
    description:
      "You currently have access to managing customers, units, and locations.",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  {
    icon: "pi pi-cog",
    title: "System Status",
    description: "All functionalities are operational and ready to use.",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
  },
  {
    icon: "pi pi-question-circle",
    title: "Support",
    description:
      "Need help? Contact the technical support team for assistance.",
    gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
  },
];
